import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'vestingDescription',
    label: 'Vesting Description',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'vestingTypeId',
    label: 'Borrower Vesting',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'mannerHeld',
    label: 'Title Held As',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'bplCompanyName',
    label: 'Company Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const titleHolderGeneralForm = {
  name: FormNames.TITLE_HOLDER_GENERAL,
  label: 'General',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
